const chargerDetailsMap = {
  displayName: "Display Name",
  siteId: "Site ID",
  serialNumber: "Serial Number",
  status: "Status",
  sku: "SKU",
  partNumber: "Part Number",
  operatingVoltage: "Operating Voltage",
  ratedCurrent: "Rated Current",
  phaseCount: "Phase Count",
  firmwareVersion: "Firmware Version",
  fwUpdatedAt: "Firmware Updated At",
  wifiConfig: "WiFi Config",
  wifiConfigDetails: "WiFi Config",
  netConfigDetails: "Network Config",
  cellularSettings: "Cellular Settings",
  timezone: "Timezone",
  lastReportedAt: "Last Reported At",
  offlineAt: "Last Offline At",
  createdAt: "Created At",
  isConnected: "Connection",
  activeConnection: "Active Connection",
  commissioningStatus: "Commissioning Status",
  isRetired: "Is Retired",
  hoControl: "Enabled",
  ocppPartnerName: "Partner Name",
  ocppUrl: "Partner URL",
  dlbEnabled: "DLB Enabled",
  dlbSource: "DLB Source",
  warrantyStartDate: "Warranty Start Date",
  warrantyDueDate: "Warranty Due Date",
  warrantyPeriod: "Warranty Period (years)",
  modelName: "Model Name",
  vendorName: "Vendor",
  phaseMode: "Phase Mode",
  protocol: "Protocol",
  protocolVersion: "Protocol Version",
  country: "Country",
  isOffGrid: "Off-Grid",
  // isDeviceReady: "Device Ready",
  chargingStatus: "Charging Status",
  chargingMode: "Charging Mode",
  localOptMode: "Local Opt Mode",
  automaticPhaseSwitching: "Auto Phase Switching",
  bidiSupported: "Bidi Supported",
  extMeterStatus: "Status",
  extMeterConnection: "Connection",
  extMeterType: "Meter Type",
  extMeterSerialNumber: "Serial Number",
  wiringConfiguration: "Wiring Configuration",
  maxCurrent: "Max Current",
  isLocallyConnected: "Gateway Connected",
  defaultChargeLevel: "Default Charge Level",
  gatewayConnectivityDetails: "Gateway Connectivity",
  evManufacturerName: "EV Manufacturer",
  evModelName: "EV Model",
  evTrimName: "EV Trim",
  evBatterySize: "Battery Size (kWh)",
  evDrivingRange: "Driving Range (km)",
  evEfficiency: "Efficiency (km/kWh)",
};

const fieldGroups = [
  {
    title: "Device Information",
    keys: [
      "displayName",
      "serialNumber",
      "siteId",
      "sku",
      "partNumber",
      "firmwareVersion",
      "fwUpdatedAt",
      "modelName",
      "vendorName",
      "country",
      "isRetired",
      "status",
      "createdAt",
      "lastReportedAt",
      "offlineAt",
      "timezone",
      "bidiSupported",
    ],
  },
  {
    title: "Electrical Specs",
    keys: [
      "operatingVoltage",
      "phaseCount",
      "phaseMode",
      "ratedCurrent",
      "maxCurrent",
      "isOffGrid",
      "wiringConfiguration",
    ],
  },
  {
    title: "Charging & EV",
    keys: ["chargingStatus", "chargingMode", "localOptMode", "defaultChargeLevel", "automaticPhaseSwitching"],
  },
  {
    title: "EV Details",
    keys: ["evManufacturerName", "evModelName", "evTrimName", "evBatterySize", "evDrivingRange", "evEfficiency"],
  },
  {
    title: "Connectivity & Configuration",
    keys: [
      "activeConnection",
      "protocol",
      "protocolVersion",
      "commissioningStatus",
      "dlbEnabled",
      "dlbSource",
      "wifiConfig",
      "wifiConfigDetails",
      "netConfigDetails",
      "cellularSettings",
      "isConnected",
      "isLocallyConnected",
      "isDeviceReady",
      "gatewayConnectivityDetails",
    ],
  },
  {
    title: "Partner Integration",
    keys: ["hoControl", "ocppPartnerName", "ocppUrl"],
  },
  {
    title: "External Meter",
    keys: ["extMeterStatus", "extMeterConnection", "extMeterType", "extMeterSerialNumber"],
  },
  {
    title: "Warranty",
    keys: ["warrantyDueDate", "warrantyPeriod", "warrantyStartDate"],
  },
];

const GROUP_ICONS = {
  "Device Information": { emoji: "🔌", color: "orange" },
  "Charging & EV": { emoji: "🔋", color: "green" },
  "EV Details": { emoji: "🚗", color: "blue" },
  "Partner Integration": { emoji: "🤝", color: "green" },
  "Connectivity & Configuration": { emoji: "📡", color: "blue" },
  "Electrical Specs": { emoji: "⚡", color: "purple" },
  "External Meter": { emoji: "📊", color: "orange" },
  Warranty: { emoji: "🛡", color: "yellow" },
};

export { chargerDetailsMap, fieldGroups, GROUP_ICONS };
